import axios from 'axios';
import { useEffect, useState } from 'react';
import { VideoCompressError, VideoTooLongError, webCodecsAvailable } from '../../lib/compress-video';

export function useVideoCaptureAvailability() {
  const codecs = webCodecsAvailable();
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const sync = () => setOnline(navigator.onLine);
    window.addEventListener('online', sync);
    window.addEventListener('offline', sync);
    return () => {
      window.removeEventListener('online', sync);
      window.removeEventListener('offline', sync);
    };
  }, []);

  return {
    captureEnabled: codecs && online !== false,
    showUpdateBrowser: !codecs,
  };
}

export function isUploadLimitError(err: unknown): boolean {
  return axios.isAxiosError(err) && err.response?.status === 409;
}

export function uploadErrorText(err: unknown, t: (key: string) => string): string {
  if (err instanceof VideoTooLongError) return t('Ролик длиннее 90 секунд');
  if (err instanceof VideoCompressError) return t('Не удалось сжать ролик');
  if (axios.isAxiosError(err)) {
    if (isUploadLimitError(err)) return t('60 / 60');
    if (!err.response) return t('Не удалось отправить ролик');
    return t('Не удалось начать загрузку');
  }
  if (err instanceof Error && err.message === 'Не удалось отправить ролик') {
    return t('Не удалось отправить ролик');
  }
  return t('Не удалось начать загрузку');
}
